import { priceOverrides } from "./priceOverrides.generated";

export interface MenuItem {
  id: string;
  name?: string; // Optional when using recipeId
  nameFr?: string;
  nameKey?: string; // Optional when using recipeId
  description?: string; // Optional when using recipeId
  descriptionFr?: string;
  descriptionKey?: string; // Optional when using recipeId
  price: number;
  category: "specials" | "lunch" | "dinner" | "grocery" | "new-arrivals";
  location: "montreal" | "delson" | "both";
  submenu?: string;
  image?: string;
  popular?: boolean;
  spicy?: boolean;
  vegetarian?: boolean;
  vegan?: boolean;
  glutenFree?: boolean;
  new?: boolean;
  recipeId?: string; // Reference to Recipe Book for shared dish information
}

export const baseMenuItems: MenuItem[] = [
  // ============================================
  // DELSON - NEW ARRIVALS
  // ============================================
  // Cava New Plates
  {
    id: "delson-fish-and-chips",
    recipeId: "fish-n-chips",
    price: 24.95,
    category: "new-arrivals",
    location: "delson",
    submenu: "delson-cava-new-plates",
  },
  {
    id: "delson-pork-chops",
    recipeId: "pork-chops",
    price: 21.95,
    category: "new-arrivals",
    location: "delson",
    submenu: "delson-cava-new-plates",
  },

  // ============================================
  // DELSON - LUNCH (MENU MIDI)
  // ============================================
  // Appetizers / Les entrées
  {
    id: "delson-lunch-appetizers-soup-of-the-day",
    recipeId: "soup-of-the-day",
    price: 4.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-lentil-greek-soup",
    recipeId: "greek-lentil-soup",
    price: 4.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-garlic-bread",
    recipeId: "garlic-bread",
    price: 6.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-garlic-cheese-bread",
    recipeId: "garlic-bread-mozzarella",
    price: 10.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-tzatziki",
    recipeId: "tzatziki",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-taramosalata",
    recipeId: "taramosalata",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-feta-olives",
    recipeId: "feta-olives",
    price: 10.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-dolmades",
    recipeId: "dolmades",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-spanakopita",
    recipeId: "spanakopita",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-marinated-artichokes",
    recipeId: "marinated-artichokes",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-marinated-palms",
    recipeId: "marinated-hearts-of-palm",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-gratin-snails",
    recipeId: "baked-escargots",
    price: 10.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-gratin-matane-shrimp",
    recipeId: "baked-matane-shrimp",
    price: 10.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-gratin-mushrooms",
    recipeId: "baked-mushrooms",
    price: 9.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-butterfly-shrimp",
    recipeId: "butterfly-shrimp-4",
    price: 16.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-spicy-sausages",
    recipeId: "spicy-sausages-appetizer",
    price: 16.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-scallops",
    recipeId: "scallops-appetizer",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-fried-calamari-1",
    recipeId: "fried-calamari-1",
    price: 18.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-fried-calamari-2",
    recipeId: "fried-calamari-2",
    price: 23.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-pikilia-1",
    recipeId: "pikilia-1",
    price: 18.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-pikilia-2",
    recipeId: "pikilia-2",
    price: 25.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-appetizers",
  },
  {
    id: "delson-lunch-appetizers-pita-bread",
    recipeId: "pita-bread",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-appetizers",
  },

  // Meal Salads / Les salades repas
  {
    id: "delson-lunch-salads-chef-salad",
    recipeId: "chef-salad",
    price: 16.95,
    category: "lunch",
    location: "delson",
    popular: false,
    vegetarian: true,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-chef-salad-grilled-chicken",
    recipeId: "chef-salad-grilled-chicken",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-chef-salad-grilled-salmon",
    recipeId: "chef-salad-grilled-salmon",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-caesar-salad",
    recipeId: "caesar-salad",
    price: 16.95,
    category: "lunch",
    location: "delson",
    popular: false,
    vegetarian: true,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-caesar-grilled-chicken",
    recipeId: "caesar-salad-grilled-chicken",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-greek-salad",
    recipeId: "greek-salad",
    price: 20.95,
    category: "lunch",
    location: "delson",
    popular: true,
    vegetarian: true,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-greek-salad-grilled-chicken",
    recipeId: "greek-salad-grilled-chicken",
    price: 28.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-salads",
  },
  {
    id: "delson-lunch-salads-vegetarian-plate",
    recipeId: "vegetarian-plate",
    price: 21.95,
    category: "lunch",
    location: "delson",
    popular: false,
    vegetarian: true,
    submenu: "delson-lunch-salads",
  },

  // Pasta / Les pâtes
  {
    id: "delson-lunch-pasta-spaghetti",
    recipeId: "spaghetti",
    price: 20.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-pasta",
  },
  {
    id: "delson-lunch-pasta-baked-spaghetti",
    recipeId: "baked-spaghetti",
    price: 22.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-pasta",
  },
  {
    id: "delson-lunch-pasta-baked-lasagna",
    recipeId: "baked-lasagna",
    price: 22.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-pasta",
  },

  // Main dishes / Plats principaux
  {
    id: "delson-lunch-main-dishes-pork-souvlaki-1",
    recipeId: "pork-souvlaki-1",
    price: 18.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-pork-souvlaki-2",
    recipeId: "pork-souvlaki-2",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-chicken-souvlaki-1",
    recipeId: "chicken-souvlaki-1",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-2",
    price: 25.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-spicy-sausages",
    recipeId: "spicy-sausages",
    price: 21.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-baked-white-fish",
    recipeId: "white-fish-baked",
    price: 18.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-breaded-white-fish",
    recipeId: "white-fish-breaded",
    price: 20.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-baked-salmon",
    recipeId: "salmon-baked",
    price: 23.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-salmon-butterfly-shrimp",
    recipeId: "salmon-butterfly-shrimp",
    price: 29.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-butterfly-shrimp",
    recipeId: "butterfly-shrimp",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-hamburger-steak",
    recipeId: "hamburger-steak-mushroom-sauce",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-chicken-skewer",
    recipeId: "chicken-skewer",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-grilled-chicken-filet",
    recipeId: "chicken-breast-grilled",
    price: 23.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-chicken-2-butterfly-shrimp",
    recipeId: "chicken-breast-grilled-butterfly-shrimp",
    price: 29.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-fried-calamari",
    recipeId: "fried-calamari",
    price: 25.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-fish-n-chips",
    recipeId: "fish-n-chips",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-pork-chops",
    recipeId: "pork-chops",
    price: 21.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-frog-legs",
    recipeId: "frog-legs",
    price: 22.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-scallops",
    recipeId: "scallops",
    price: 22.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-chicken-parmesan",
    recipeId: "chicken-parmesan",
    price: 26.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-shish-kebab",
    recipeId: "shish-kebab",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-moussaka",
    recipeId: "moussaka",
    price: 24.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-cava-grecque-steak",
    recipeId: "cava-grecque-steak",
    price: 29.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-lamb-chops",
    recipeId: "lamb-chops",
    price: 32.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-filet-mignon-skewer",
    recipeId: "filet-mignon-skewer",
    price: 34.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-filet-mignon-medallion",
    recipeId: "filet-mignon-medallion",
    price: 34.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },
  {
    id: "delson-lunch-main-dishes-filet-mignon-butterfly-shrimp",
    recipeId: "filet-mignon-butterfly-shrimp",
    price: 40.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-main-dishes",
  },

  // Menu Midi - Sandwich only / Sandwich seulement
  {
    id: "delson-lunch-midi-sandwich-pork-souvlaki-1",
    recipeId: "pork-souvlaki-pita-1",
    price: 13.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-sandwich",
  },
  {
    id: "delson-lunch-midi-sandwich-pork-souvlaki-2",
    recipeId: "pork-souvlaki-pita-2",
    price: 25.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-sandwich",
  },
  {
    id: "delson-lunch-midi-sandwich-chicken-souvlaki-1",
    recipeId: "chicken-souvlaki-pita-1",
    price: 14.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-sandwich",
  },
  {
    id: "delson-lunch-midi-sandwich-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-pita-2",
    price: 27.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-sandwich",
  },
  {
    id: "delson-lunch-midi-sandwich-gyros-1",
    recipeId: "gyro-pita-1",
    price: 14.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-sandwich",
  },
  {
    id: "delson-lunch-midi-sandwich-gyros-2",
    recipeId: "gyro-pita-2",
    price: 27.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-sandwich",
  },

  // Menu Midi - Plate / Assiette
  {
    id: "delson-lunch-midi-plate-pork-souvlaki-1",
    recipeId: "pork-souvlaki-plate-1",
    price: 18.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-plate",
  },
  {
    id: "delson-lunch-midi-plate-pork-souvlaki-2",
    recipeId: "pork-souvlaki-plate-2",
    price: 30.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-plate",
  },
  {
    id: "delson-lunch-midi-plate-chicken-souvlaki-1",
    recipeId: "chicken-souvlaki-plate-1",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-plate",
  },
  {
    id: "delson-lunch-midi-plate-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-plate-2",
    price: 32.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-plate",
  },
  {
    id: "delson-lunch-midi-plate-gyros-1",
    recipeId: "gyro-plate-1",
    price: 19.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-midi-plate",
  },
  {
    id: "delson-lunch-midi-plate-gyros-2",
    recipeId: "gyro-plate-2",
    price: 32.95,
    category: "lunch",
    location: "delson",
    popular: true,
    submenu: "delson-lunch-midi-plate",
  },

  // Beverages / Breuvages
  {
    id: "delson-lunch-beverages-soft-drink",
    recipeId: "liqueur",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-filter-coffee",
    recipeId: "filter-coffee",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-espresso",
    recipeId: "espresso",
    price: 3.25,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-cappuccino",
    recipeId: "cappuccino",
    price: 4.25,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-tea",
    recipeId: "tea-herbal-tea",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-milk",
    recipeId: "glass-of-milk",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },
  {
    id: "delson-lunch-beverages-juice",
    recipeId: "glass-of-juice",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-beverages",
  },

  // Desserts
  {
    id: "delson-lunch-desserts-baklava",
    recipeId: "baklava",
    price: 4.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-galaktoboureko",
    recipeId: "galaktoboureko",
    price: 4.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-creme-caramel",
    recipeId: "creme-caramel",
    price: 4.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-cake-of-the-day",
    recipeId: "cake-of-the-day",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-pouding-chomeur",
    recipeId: "pouding-chomeur",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-rice-pudding",
    recipeId: "rice-pudding",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },
  {
    id: "delson-lunch-desserts-ice-cream",
    recipeId: "ice-cream",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-desserts",
  },

  // Extras
  {
    id: "delson-lunch-extras-tzatziki",
    recipeId: "tzatziki",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-taramosalata",
    recipeId: "taramosalata",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-mushroom-sauce",
    recipeId: "mushroom-sauce",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-pepper-sauce",
    recipeId: "pepper-sauce",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-vinaigrette",
    recipeId: "vinaigrette",
    price: 2.0,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-butterfly-shrimp",
    recipeId: "butterfly-shrimp",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-langoustine",
    recipeId: "langoustine",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-scallop",
    recipeId: "scallop",
    price: 3.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },
  {
    id: "delson-lunch-extras-feta-cheese",
    recipeId: "feta-cheese",
    price: 2.95,
    category: "lunch",
    location: "delson",
    popular: false,
    submenu: "delson-lunch-extras",
  },

  // ============================================
  // DELSON - DINNER
  // ============================================
  // Appetizers / Les entrées
  {
    id: "delson-dinner-appetizers-soup-of-the-day",
    recipeId: "soup-of-the-day",
    price: 4.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-lentil-greek-soup",
    recipeId: "greek-lentil-soup",
    price: 4.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-garlic-bread",
    recipeId: "garlic-bread",
    price: 6.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-garlic-cheese-bread",
    recipeId: "garlic-bread-mozzarella",
    price: 10.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-tzatziki",
    recipeId: "tzatziki",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-taramosalata",
    recipeId: "taramosalata",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-feta-olives",
    recipeId: "feta-olives",
    price: 10.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-dolmades",
    recipeId: "dolmades",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-spanakopita",
    recipeId: "spanakopita",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-marinated-artichokes",
    recipeId: "marinated-artichokes",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-marinated-palms",
    recipeId: "marinated-hearts-of-palm",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-gratin-snails",
    recipeId: "baked-escargots",
    price: 10.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-gratin-matane-shrimp",
    recipeId: "baked-matane-shrimp",
    price: 10.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-gratin-mushrooms",
    recipeId: "baked-mushrooms",
    price: 9.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-butterfly-shrimp",
    recipeId: "butterfly-shrimp-4",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-scallops",
    recipeId: "scallops-appetizer",
    price: 19.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-spicy-sausages",
    recipeId: "spicy-sausages-appetizer",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-fried-calamari-1",
    recipeId: "fried-calamari-1",
    price: 18.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-fried-calamari-2",
    recipeId: "fried-calamari-2",
    price: 23.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-pikilia-1",
    recipeId: "pikilia-1",
    price: 18.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-pikilia-2",
    recipeId: "pikilia-2",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  {
    id: "delson-dinner-appetizers-pita-bread",
    recipeId: "pita-bread",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-appetizers",
  },
  // Cava Special / Spécial Cava
  {
    id: "delson-dinner-special-cava-pork-souvlaki-2",
    recipeId: "pork-souvlaki-2",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-2",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-chicken-skewer",
    recipeId: "chicken-skewer",
    price: 26.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-grilled-chicken-fillet",
    recipeId: "chicken-breast-grilled",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-shish-kebab",
    recipeId: "shish-kebab",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-moussaka",
    recipeId: "moussaka",
    price: 26.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  {
    id: "delson-dinner-special-cava-pork-chops",
    recipeId: "pork-chops",
    price: 22.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-special-cava",
  },
  // Red Meat / Viande Rouge
  {
    id: "delson-dinner-red-meat-filet-mignon-medallion",
    recipeId: "filet-mignon-medallions",
    price: 35.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-filet-mignon-skewer",
    recipeId: "filet-mignon-skewer",
    price: 36.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-cava-grecque-steak",
    recipeId: "cava-grecque-steak",
    price: 30.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-ribeye-steak",
    recipeId: "ribeye-steak",
    price: 40.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-sirloin-steak",
    recipeId: "sirloin-steak",
    price: 40.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-pepper-steak",
    recipeId: "pepper-steak",
    price: 40.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  {
    id: "delson-dinner-red-meat-lamb-chops",
    recipeId: "lamb-chops",
    price: 34.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-red-meat",
  },
  // Seafood / Fruits de mer
  {
    id: "delson-dinner-seafood-butterfly-shrimp-plate",
    recipeId: "butterfly-shrimp-plate",
    price: 30.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-langoustines-plate",
    recipeId: "langoustines-plate",
    price: 35.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-grilled-scallops-plate",
    recipeId: "grilled-scallops-plate",
    price: 34.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-frog-legs",
    recipeId: "frog-legs",
    price: 30.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-baked-salmon",
    recipeId: "salmon-baked",
    price: 26.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-salmon-and-butterfly-shrimp-plate",
    recipeId: "salmon-and-butterfly-shrimp-plate",
    price: 35.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-fisherman-plate",
    recipeId: "fisherman-plate",
    price: 48.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-baked-white-fish",
    recipeId: "baked-white-fish-fillet",
    price: 23.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-breaded-white-fish",
    recipeId: "breaded-white-fish-fillet",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-scallops-plate",
    recipeId: "scallops-plate",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-fish-n-chips",
    recipeId: "fish-n-chips",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-fried-calamari-plate",
    recipeId: "fried-calamari-plate",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  {
    id: "delson-dinner-seafood-calamari-and-butterfly-shrimp-plate",
    recipeId: "calamari-and-butterfly-shrimp-plate",
    price: 32.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-seafood",
  },
  // Surf & Turf / Terre et mer
  {
    id: "delson-dinner-surf-turf-filet-mignon-butterfly-shrimp",
    recipeId: "filet-mignon-butterfly-shrimp",
    price: 42.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-surf-turf",
  },
  {
    id: "delson-dinner-surf-turf-grilled-chicken-butterfly-shrimp",
    recipeId: "grilled-chicken-breast-butterfly-shrimp",
    price: 34.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-surf-turf",
  },
  {
    id: "delson-dinner-surf-turf-chicken-brochette-butterfly-shrimp",
    recipeId: "chicken-brochette-butterfly-shrimp",
    price: 35.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-surf-turf",
  },
  {
    id: "delson-dinner-surf-turf-chicken-brochette-fried-calamari",
    recipeId: "chicken-brochette-fried-calamari",
    price: 36.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-surf-turf",
  },
  {
    id: "delson-dinner-surf-turf-chicken-brochette-scallops",
    recipeId: "chicken-brochette-scallops",
    price: 36.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-surf-turf",
  },
  // Pasta / Les pâtes
  {
    id: "delson-dinner-pasta-spaghetti",
    recipeId: "spaghetti",
    price: 20.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pasta",
  },
  {
    id: "delson-dinner-pasta-baked-spaghetti",
    recipeId: "baked-spaghetti",
    price: 22.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pasta",
  },
  {
    id: "delson-dinner-pasta-baked-lasagna",
    recipeId: "baked-lasagna",
    price: 22.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pasta",
  },
  // Salads / Les salades repas
  {
    id: "delson-dinner-salads-chef-salad",
    recipeId: "chef-salad",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-chef-salad-with-grilled-chicken",
    recipeId: "chef-salad-grilled-chicken",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-chef-salad-with-grilled-salmon",
    recipeId: "chef-salad-grilled-salmon",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-caesar-salad",
    recipeId: "caesar-salad",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-caesar-with-grilled-chicken",
    recipeId: "caesar-salad-grilled-chicken",
    price: 24.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-greek-salad",
    recipeId: "greek-salad",
    price: 20.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-greek-salad-with-grilled-chicken",
    recipeId: "greek-salad-grilled-chicken",
    price: 28.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  {
    id: "delson-dinner-salads-vegetarian-plate",
    recipeId: "vegetarian-plate",
    price: 21.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-salads",
  },
  // Pitas - Sandwich only
  {
    id: "delson-dinner-pitas-sandwich-pork-souvlaki-1",
    recipeId: "pork-souvlaki-pita-1",
    price: 13.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  {
    id: "delson-dinner-pitas-sandwich-pork-souvlaki-2",
    recipeId: "pork-souvlaki-pita-2",
    price: 25.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  {
    id: "delson-dinner-pitas-sandwich-chicken-souvlaki-1",
    recipeId: "chicken-souvlaki-pita-1",
    price: 14.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  {
    id: "delson-dinner-pitas-sandwich-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-pita-2",
    price: 27.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  {
    id: "delson-dinner-pitas-sandwich-gyro-1",
    recipeId: "gyro-pita-1",
    price: 14.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  {
    id: "delson-dinner-pitas-sandwich-gyro-2",
    recipeId: "gyro-pita-2",
    price: 27.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-sandwich",
  },
  // Pitas - Plate / Assiette
  {
    id: "delson-dinner-pitas-plate-pork-souvlaki-1",
    recipeId: "pork-souvlaki-plate-1",
    price: 18.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  {
    id: "delson-dinner-pitas-plate-pork-souvlaki-2",
    recipeId: "pork-souvlaki-plate-2",
    price: 30.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  {
    id: "delson-dinner-pitas-plate-chicken-souvlaki-1",
    recipeId: "chicken-souvlaki-plate-1",
    price: 19.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  {
    id: "delson-dinner-pitas-plate-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-plate-2",
    price: 32.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  {
    id: "delson-dinner-pitas-plate-gyro-1",
    recipeId: "gyro-plate-1",
    price: 19.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  {
    id: "delson-dinner-pitas-plate-gyro-2",
    recipeId: "gyro-plate-2",
    price: 32.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-pitas-plate",
  },
  // Kids menu / Menu pour les enfants
  {
    id: "delson-dinner-kids-menu-souvlaki-single",
    recipeId: "kids-souvlaki-single",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  {
    id: "delson-dinner-kids-menu-chicken-souvlaki",
    recipeId: "kids-chicken-souvlaki",
    price: 18.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  {
    id: "delson-dinner-kids-menu-chicken-nuggets-plate",
    recipeId: "kids-chicken-nuggets",
    price: 17.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  {
    id: "delson-dinner-kids-menu-spaghetti",
    recipeId: "kids-spaghetti",
    price: 15.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  {
    id: "delson-dinner-kids-menu-gratin-spaghetti",
    recipeId: "kids-gratin-spaghetti",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  {
    id: "delson-dinner-kids-menu-gratin-lasagna",
    recipeId: "kids-gratin-lasagna",
    price: 16.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-kids-menu",
  },
  // Beverages / Breuvages
  {
    id: "delson-dinner-beverages-soft-drink",
    recipeId: "liqueur",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-filter-coffee",
    recipeId: "filter-coffee",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-espresso",
    recipeId: "espresso",
    price: 3.25,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-cappuccino",
    recipeId: "cappuccino",
    price: 4.25,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-tea",
    recipeId: "tea-herbal-tea",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-milk",
    recipeId: "glass-of-milk",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  {
    id: "delson-dinner-beverages-juice",
    recipeId: "glass-of-juice",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-beverages",
  },
  // Desserts
  {
    id: "delson-dinner-desserts-baklava",
    recipeId: "baklava",
    price: 4.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-galaktoboureko",
    recipeId: "galaktoboureko",
    price: 4.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-creme-caramel",
    recipeId: "creme-caramel",
    price: 4.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-cake-of-the-day",
    recipeId: "cake-of-the-day",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-pouding-chomeur",
    recipeId: "pouding-chomeur",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-rice-pudding",
    recipeId: "rice-pudding",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  {
    id: "delson-dinner-desserts-ice-cream",
    recipeId: "ice-cream",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-desserts",
  },
  // Extras
  {
    id: "delson-dinner-extras-tzatziki",
    recipeId: "tzatziki",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-taramosalata",
    recipeId: "taramosalata",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-mushroom-sauce",
    recipeId: "mushroom-sauce",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-pepper-sauce",
    recipeId: "pepper-sauce",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-vinaigrette",
    recipeId: "vinaigrette",
    price: 2,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-butterfly-shrimp",
    recipeId: "butterfly-shrimp",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-langoustine",
    recipeId: "langoustine",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-scallop",
    recipeId: "scallop",
    price: 3.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },
  {
    id: "delson-dinner-extras-feta-cheese",
    recipeId: "feta-cheese",
    price: 2.95,
    category: "dinner",
    location: "delson",
    popular: false,
    submenu: "delson-dinner-extras",
  },

  // DELSOIN SPECIALS
  // ============================================
  {
    id: "pork-souvlaki-pita-1",
    recipeId: "pork-souvlaki-pita-1",
    price: 13.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "pork-souvlaki-pita-2",
    recipeId: "pork-souvlaki-pita-2",
    price: 25.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "chicken-souvlaki-pita-1",
    recipeId: "chicken-souvlaki-pita-1",
    price: 14.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "chicken-souvlaki-pita-2",
    recipeId: "chicken-souvlaki-pita-2",
    price: 27.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "gyro-pita-1",
    recipeId: "gyro-pita-1",
    price: 14.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "gyro-pita-2",
    recipeId: "gyro-pita-2",
    price: 27.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "pork-souvlaki-plate-1",
    recipeId: "pork-souvlaki-plate-1",
    price: 17.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "pork-souvlaki-plate-2",
    recipeId: "pork-souvlaki-plate-2",
    price: 30.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "chicken-souvlaki-plate-1",
    recipeId: "chicken-souvlaki-plate-1",
    price: 18.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "chicken-souvlaki-plate-2",
    recipeId: "chicken-souvlaki-plate-2",
    price: 32.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "gyro-plate-1",
    recipeId: "gyro-plate-1",
    price: 18.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },
  {
    id: "gyro-plate-2",
    recipeId: "gyro-plate-2",
    price: 32.95,
    category: "specials",
    location: "delson",
    popular: false,
    submenu: "delson-new-pita-specials",
  },

  // ============================================
  // MONTREAL - LES PLATS PRINCIPAUX (MAIN DISHES)
  // Note: All dishes served with house rice, Greek potatoes, soup or choice of salad
  // Extras available: Caesar Salad +$2.95, Greek Salad +$3.95, Dessert +$3.00
  // ============================================
  {
    id: "montreal-souvlaki-pork-1",
    recipeId: "pork-souvlaki-1",
    price: 18.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-souvlaki-pork-2",
    recipeId: "pork-souvlaki-2",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    popular: true,
    submenu: "main-dishes",
  },
  {
    id: "montreal-souvlaki-chicken-1",
    recipeId: "chicken-souvlaki-1",
    price: 18.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-souvlaki-chicken-2",
    recipeId: "chicken-souvlaki-2",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    popular: true,
    submenu: "main-dishes",
  },
  {
    id: "montreal-spicy-sausages",
    recipeId: "spicy-sausages",
    price: 21.95,
    category: "lunch",
    location: "montreal",
    spicy: true,
    submenu: "main-dishes",
  },
  {
    id: "montreal-white-fish-baked",
    recipeId: "baked-white-fish",
    price: 18.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-white-fish-breaded",
    recipeId: "breaded-white-fish",
    price: 20.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-salmon-baked",
    recipeId: "baked-salmon",
    price: 23.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-salmon-butterfly-shrimp",
    recipeId: "salmon-butterfly-shrimp",
    price: 29.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-moussaka",
    recipeId: "moussaka",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    popular: true,
    submenu: "main-dishes",
  },
  {
    id: "montreal-butterfly-shrimp-dinner",
    recipeId: "butterfly-shrimp",
    price: 19.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-hamburger-steak",
    recipeId: "hamburger-steak",
    price: 19.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-chicken-brochette",
    recipeId: "chicken-brochette",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-grilled-chicken-breast",
    recipeId: "grilled-chicken-breast",
    price: 23.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-chicken-breast-shrimp",
    recipeId: "grilled-chicken-butterfly-shrimp",
    price: 29.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-fried-calamari-dinner",
    recipeId: "fried-calamari",
    price: 25.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-fish-n-chips",
    recipeId: "fish-n-chips",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-pork-chops",
    recipeId: "pork-chops",
    price: 21.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-frog-legs",
    recipeId: "frog-legs",
    price: 22.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-scallops-dinner",
    recipeId: "scallops",
    price: 22.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-chicken-parmesan",
    recipeId: "chicken-parmesan",
    price: 26.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-pork-shish-kebab",
    recipeId: "pork-shish-kebab",
    price: 24.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-steak-cava",
    recipeId: "steak-cava",
    price: 29.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-lamb-chops",
    recipeId: "lamb-chops",
    price: 32.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-filet-mignon-brochette",
    recipeId: "filet-mignon-brochette",
    price: 34.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-filet-mignon-medallion",
    recipeId: "filet-mignon-medallion",
    price: 34.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },
  {
    id: "montreal-filet-mignon-shrimp",
    recipeId: "filet-mignon-butterfly-shrimp",
    price: 40.95,
    category: "lunch",
    location: "montreal",
    submenu: "main-dishes",
  },

  // ============================================
  // MONTREAL - PITAS
  // Note: Pita only. Caesar Salad +$2.95, Greek Salad +$4.95
  // ============================================
  {
    id: "montreal-pita-pork-1",
    recipeId: "pork-souvlaki-1",
    price: 13.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
  },
  {
    id: "montreal-pita-pork-2",
    recipeId: "pork-souvlaki-2",
    price: 25.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
  },
  {
    id: "montreal-pita-chicken-1",
    recipeId: "chicken-souvlaki-1",
    price: 14.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
  },
  {
    id: "montreal-pita-chicken-2",
    recipeId: "chicken-souvlaki-2",
    price: 27.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
  },
  {
    id: "montreal-gyro-pita-1",
    recipeId: "gyro-1",
    price: 14.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
    popular: true,
  },
  {
    id: "montreal-gyro-pita-2",
    recipeId: "gyro-2",
    price: 27.95,
    category: "lunch",
    location: "montreal",
    submenu: "pitas",
  },

  // // ============================================
  // // MONTREAL - LES SALADES REPAS (MEAL SALADS)
  // // ============================================
  // {
  //   id: "montreal-chef-salad",
  //   name: "Chef Salad",
  //   nameFr: "Salade du chef",
  //   nameKey: "menuItems.chefSalad.name",
  //   description: "Chef salad",
  //   descriptionFr: "Salade du chef",
  //   descriptionKey: "menuItems.chefSalad.description",
  //   price: 16.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-chef-salad-chicken",
  //   name: "Chef Salad with Grilled Chicken",
  //   nameFr: "Salade du chef avec poulet grillé",
  //   nameKey: "menuItems.chefSaladChicken.name",
  //   description: "Chef salad with grilled chicken",
  //   descriptionFr: "Salade du chef avec poulet grillé",
  //   descriptionKey: "menuItems.chefSaladChicken.description",
  //   price: 24.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-chef-salad-salmon",
  //   name: "Chef Salad with Grilled Salmon",
  //   nameFr: "Salade du chef avec saumon grillé",
  //   nameKey: "menuItems.chefSaladSalmon.name",
  //   description: "Chef salad with grilled salmon",
  //   descriptionFr: "Salade du chef avec saumon grillé",
  //   descriptionKey: "menuItems.chefSaladSalmon.description",
  //   price: 24.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-caesar-salad",
  //   name: "Caesar Salad",
  //   nameFr: "Salade César",
  //   nameKey: "menuItems.caesarSalad.name",
  //   description: "Caesar salad",
  //   descriptionFr: "Salade César",
  //   descriptionKey: "menuItems.caesarSalad.description",
  //   price: 16.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-caesar-salad-chicken",
  //   name: "Caesar Salad with Grilled Chicken",
  //   nameFr: "Salade César avec poulet grillé",
  //   nameKey: "menuItems.caesarSaladChicken.name",
  //   description: "Caesar salad with grilled chicken",
  //   descriptionFr: "Salade César avec poulet grillé",
  //   descriptionKey: "menuItems.caesarSaladChicken.description",
  //   price: 24.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-greek-salad-meal",
  //   name: "Greek Salad",
  //   nameFr: "Salade grecque",
  //   nameKey: "menuItems.greekSaladMeal.name",
  //   description: "Greek salad",
  //   descriptionFr: "Salade grecque",
  //   descriptionKey: "menuItems.greekSaladMeal.description",
  //   price: 20.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  //   vegetarian: true,
  // },
  // {
  //   id: "montreal-greek-salad-chicken",
  //   name: "Greek Salad with Grilled Chicken",
  //   nameFr: "Salade grecque avec poulet grillé",
  //   nameKey: "menuItems.greekSaladChicken.name",
  //   description: "Greek salad with grilled chicken",
  //   descriptionFr: "Salade grecque avec poulet grillé",
  //   descriptionKey: "menuItems.greekSaladChicken.description",
  //   price: 28.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  // },
  // {
  //   id: "montreal-vegetarian-plate",
  //   name: "Vegetarian Plate",
  //   nameFr: "Assiette végétarienne",
  //   nameKey: "menuItems.vegetarianPlate.name",
  //   description: "Vegetarian plate",
  //   descriptionFr: "Assiette végétarienne",
  //   descriptionKey: "menuItems.vegetarianPlate.description",
  //   price: 21.95,
  //   category: "lunch",
  //   location: "montreal",
  //   submenu: "salads",
  //   vegetarian: true,
  // },

  // ============================================
  // MONTREAL - LES PÂTES (PASTA)
  // ============================================
  {
    id: "montreal-spaghetti-meat-sauce",
    recipeId: "spaghetti",
    price: 20.95,
    category: "lunch",
    location: "montreal",
    submenu: "pasta",
  },
  {
    id: "montreal-spaghetti-gratinee",
    recipeId: "baked-spaghetti",
    price: 22.95,
    category: "lunch",
    location: "montreal",
    submenu: "pasta",
  },
  {
    id: "montreal-lasagna-gratinee",
    recipeId: "baked-lasagna",
    price: 22.95,
    category: "lunch",
    location: "montreal",
    submenu: "pasta",
  },

  // ============================================
  // MONTREAL - EXTRAS
  // ============================================
  {
    id: "montreal-extra-tzatziki",
    recipeId: "tzatziki",
    price: 2.0,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-taramosalata",
    recipeId: "taramosalata",
    price: 2.0,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-mushroom-sauce",
    recipeId: "mushroom-sauce",
    price: 2.0,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-pepper-sauce",
    recipeId: "pepper-sauce",
    price: 2.0,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-vinaigrette",
    recipeId: "vinaigrette",
    price: 2.0,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-butterfly-shrimp",
    recipeId: "butterfly-shrimp",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-langoustine",
    recipeId: "langoustine",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-scallop",
    recipeId: "scallop",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-frog-leg",
    recipeId: "frog-leg",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },
  {
    id: "montreal-extra-feta",
    recipeId: "feta-cheese",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "extras",
  },

  // ============================================
  // MONTREAL - BREUVAGES (BEVERAGES)
  // ============================================
  {
    id: "montreal-soft-drink",
    recipeId: "liqueur",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-filter-coffee",
    recipeId: "filter-coffee",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-espresso",
    recipeId: "espresso",
    price: 3.25,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-cappuccino",
    recipeId: "cappuccino",
    price: 4.25,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-tea",
    recipeId: "tea-herbal-tea",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-milk",
    recipeId: "glass-of-milk",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },
  {
    id: "montreal-juice",
    recipeId: "glass-of-juice",
    price: 2.95,
    category: "lunch",
    location: "montreal",
    submenu: "beverages",
  },

  // ============================================
  // MONTREAL - DESSERTS
  // ============================================
  {
    id: "montreal-baklava",
    recipeId: "baklava",
    price: 4.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
    popular: true,
  },
  {
    id: "montreal-galaktoboureko",
    recipeId: "galaktoboureko",
    price: 4.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },
  {
    id: "montreal-creme-caramel",
    recipeId: "creme-caramel",
    price: 4.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },
  {
    id: "montreal-cake-day",
    recipeId: "cake-of-the-day",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },
  {
    id: "montreal-pouding-chomeur",
    recipeId: "pouding-chomeur",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },
  {
    id: "montreal-rice-pudding",
    recipeId: "rice-pudding",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },
  {
    id: "montreal-ice-cream",
    recipeId: "ice-cream",
    price: 3.95,
    category: "lunch",
    location: "montreal",
    submenu: "desserts",
  },

  // ============================================
  // MONTREAL DINNER - LES ENTRÉES (APPETIZERS)
  // Note: Same as lunch appetizers
  // ============================================
  {
    id: "montreal-dinner-soup-day",
    recipeId: "soup-of-the-day",
    price: 4.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-greek-lentil-soup",
    recipeId: "greek-lentil-soup",
    price: 4.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-garlic-bread",
    recipeId: "garlic-bread",
    price: 6.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-garlic-bread-cheese",
    recipeId: "garlic-bread-mozzarella",
    price: 10.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-tzatziki",
    recipeId: "tzatziki",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
    popular: true,
  },
  {
    id: "montreal-dinner-taramosalata",
    recipeId: "taramosalata",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-feta-olives",
    recipeId: "feta-olives",
    price: 10.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-dolmades",
    recipeId: "dolmades",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-spanakopita",
    recipeId: "spanakopita",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
    popular: true,
  },
  {
    id: "montreal-dinner-marinated-artichokes",
    recipeId: "marinated-artichokes",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-hearts-of-palm",
    recipeId: "marinated-hearts-of-palm",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-escargots",
    recipeId: "baked-escargots",
    price: 10.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-shrimp-matane",
    recipeId: "baked-matane-shrimp",
    price: 10.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-mushrooms-gratinee",
    recipeId: "baked-mushrooms",
    price: 9.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-butterfly-shrimp-4",
    recipeId: "butterfly-shrimp-4",
    price: 16.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-spicy-sausages-app",
    recipeId: "spicy-sausages-appetizer",
    price: 16.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-scallops-app",
    recipeId: "scallops-appetizer",
    price: 19.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-fried-calamari-1",
    recipeId: "fried-calamari-1",
    price: 18.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-fried-calamari-2",
    recipeId: "fried-calamari-2",
    price: 23.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },
  {
    id: "montreal-dinner-pikilia-1",
    recipeId: "pikilia-1",
    price: 18.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
    popular: true,
  },
  {
    id: "montreal-dinner-pikilia-2",
    recipeId: "pikilia-2",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
    popular: true,
  },
  {
    id: "montreal-dinner-pita-bread-single",
    recipeId: "pita-bread",
    price: 2.0,
    category: "dinner",
    location: "montreal",
    submenu: "appetizers",
  },

  // ============================================
  // MONTREAL DINNER - LES SALADES REPAS (MEAL SALADS)
  // Note: Soup included
  // ============================================
  {
    id: "montreal-dinner-chef-salad",
    recipeId: "chef-salad",
    price: 16.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-chef-salad-chicken",
    recipeId: "chef-salad-chicken",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-chef-salad-salmon",
    recipeId: "chef-salad-salmon",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-caesar-salad",
    recipeId: "caesar-salad",
    price: 16.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-caesar-salad-chicken",
    recipeId: "caesar-salad-chicken",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-greek-salad-meal",
    recipeId: "greek-salad",
    price: 20.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-greek-salad-chicken",
    recipeId: "greek-salad-chicken",
    price: 28.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },
  {
    id: "montreal-dinner-vegetarian-plate",
    recipeId: "vegetarian-plate",
    price: 21.95,
    category: "dinner",
    location: "montreal",
    submenu: "salads",
  },

  // ============================================
  // MONTREAL DINNER - SPÉCIAL CAVA
  // All plates served with house rice, Greek potatoes, soup or chef's salad
  // Table d'hôte available (includes coffee or tea and dessert): +$6.00
  // ============================================
  {
    id: "montreal-dinner-pork-souvlaki-2",
    recipeId: "pork-souvlaki-2",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    popular: true,
    submenu: "special-cava",
  },
  {
    id: "montreal-dinner-chicken-souvlaki-2",
    recipeId: "chicken-souvlaki-2",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    popular: true,
    submenu: "special-cava",
  },
  {
    id: "montreal-dinner-chicken-brochette",
    recipeId: "chicken-brochette",
    price: 26.95,
    category: "dinner",
    location: "montreal",
    submenu: "special-cava",
  },
  {
    id: "montreal-dinner-grilled-chicken-breast",
    recipeId: "grilled-chicken-breast",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    submenu: "special-cava",
  },
  {
    id: "montreal-dinner-pork-brochette",
    recipeId: "pork-brochette",
    price: 24.95,
    category: "dinner",
    location: "montreal",
    submenu: "special-cava",
  },
  {
    id: "montreal-dinner-moussaka",
    recipeId: "moussaka",
    price: 26.95,
    category: "dinner",
    location: "montreal",
    popular: true,
    submenu: "special-cava",
  },

  {
    id: "montreal-dinner-pork-chops",
    recipeId: "pork-chops",
    price: 22.95,
    category: "dinner",
    location: "montreal",
    submenu: "special-cava",
  },

  // ============================================
  // MONTREAL DINNER - VIANDE ROUGE (RED MEAT)
  // All plates served with house rice, Greek potatoes, soup or chef's salad
  // Table d'hôte available (includes coffee or tea and dessert): +$6.00
  // ============================================
  {
    id: "montreal-dinner-filet-mignon-medallions",
    recipeId: "filet-mignon-medallions",
    price: 35.95,
    category: "dinner",
    location: "montreal",
    popular: true,
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-filet-mignon-brochette",
    recipeId: "filet-mignon-brochette",
    price: 36.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-steak-cava",
    recipeId: "steak-a-la-cava",
    price: 30.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-ribeye-steak",
    recipeId: "ribeye-steak",
    price: 40.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-sirloin-steak",
    recipeId: "sirloin-steak",
    price: 40.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-pepper-steak",
    recipeId: "pepper-steak",
    price: 40.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },
  {
    id: "montreal-dinner-lamb-chops",
    recipeId: "lamb-chops",
    price: 34.95,
    category: "dinner",
    location: "montreal",
    submenu: "red-meat",
  },

  // ============================================
  // MONTREAL DINNER - FRUIT DE MER (SEAFOOD)
  // All plates served with house rice, Greek potatoes, soup or chef's salad
  // Table d'hôte available (includes coffee or tea and dessert): +$6.00
  // ============================================
  {
    id: "montreal-dinner-butterfly-shrimp-plate",
    recipeId: "butterfly-shrimp-plate",
    price: 30.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-langoustines-plate",
    recipeId: "langoustines-plate",
    price: 35.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-grilled-scallops-plate",
    recipeId: "grilled-scallops-plate",
    price: 34.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-frog-legs",
    recipeId: "frog-legs",
    price: 30.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-baked-salmon",
    recipeId: "baked-salmon-fillet",
    price: 26.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-salmon-shrimp-plate",
    recipeId: "salmon-and-butterfly-shrimp-plate",
    price: 35.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-fisherman-plate",
    recipeId: "fisherman-plate",
    price: 48.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
    popular: true,
  },
  {
    id: "montreal-dinner-baked-white-fish",
    recipeId: "baked-white-fish-fillet",
    price: 23.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-breaded-white-fish",
    recipeId: "breaded-white-fish-fillet",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-scallops-plate",
    recipeId: "scallops-plate",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-fish-n-chips",
    recipeId: "fish-n-chips",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-fried-calamari-plate",
    recipeId: "fried-calamari-plate",
    price: 25.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },
  {
    id: "montreal-dinner-calamari-shrimp-plate",
    recipeId: "calamari-and-butterfly-shrimp-plate",
    price: 32.95,
    category: "dinner",
    location: "montreal",
    submenu: "seafood",
  },

  // ============================================
  // MONTREAL DINNER - TERRE ET MER (SURF & TURF)
  // All plates served with house rice, Greek potatoes, soup or chef's salad
  // Table d'hôte available (includes coffee or tea and dessert): +$6.00
  // ============================================
  {
    id: "montreal-dinner-filet-mignon-shrimp",
    recipeId: "filet-mignon-butterfly-shrimp",
    price: 42.95,
    category: "dinner",
    location: "montreal",
    popular: true,
    submenu: "surf-turf",
  },
  {
    id: "montreal-dinner-chicken-breast-shrimp",
    recipeId: "grilled-chicken-breast-butterfly-shrimp",
    price: 34.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "surf-turf",
  },
  {
    id: "montreal-dinner-chicken-brochette-shrimp",
    recipeId: "chicken-brochette-butterfly-shrimp",
    price: 35.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "surf-turf",
  },
  {
    id: "montreal-dinner-chicken-brochette-calamari",
    recipeId: "chicken-brochette-fried-calamari",
    price: 36.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "surf-turf",
  },
  {
    id: "montreal-dinner-chicken-brochette-scallops",
    recipeId: "chicken-brochette-scallops",
    price: 36.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "surf-turf",
  },

  // ============================================
  // MONTREAL DINNER - MENU POUR LES ENFANTS (KIDS MENU)
  // All kids plates include dessert
  // ============================================
  {
    id: "montreal-dinner-kids-pork-souvlaki",
    recipeId: "kids-pork-souvlaki",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  {
    id: "montreal-dinner-kids-chicken-souvlaki",
    recipeId: "kids-chicken-souvlaki",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  {
    id: "montreal-dinner-kids-chicken-nuggets",
    recipeId: "kids-chicken-nuggets",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  {
    id: "montreal-dinner-kids-spaghetti",
    recipeId: "kids-spaghetti",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  {
    id: "montreal-dinner-kids-spaghetti-baked",
    recipeId: "kids-baked-spaghetti",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  {
    id: "montreal-dinner-kids-lasagna",
    recipeId: "kids-lasagna",
    price: 15.95,
    category: "dinner",
    location: "montreal",
    popular: false,
    submenu: "kids-menu",
  },
  // ============================================
  // DELSON - CAVA GROCERY
  // ============================================
  /* ---------------------- SOUPS ---------------------- */
  {
    id: "soup-2l",
    recipeId: "soup-2l",
    price: 22.0,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-soups",
  },
  {
    id: "soup-4l",
    recipeId: "soup-4l",
    price: 32.0,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-soups",
  },

  /* ---------------------- DIPS ---------------------- */
  {
    id: "dip-tzatziki",
    recipeId: "dip-tzatziki",
    price: 10.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-dips",
  },
  {
    id: "dip-taramosalata",
    recipeId: "dip-taramosalata",
    price: 10.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-dips",
  },
  {
    id: "dip-creamy-vinaigrette",
    recipeId: "dip-creamy-vinaigrette",
    price: 10.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-dips",
  },

  /* ---------------------- SAUCES ---------------------- */
  {
    id: "sauce-mushroom",
    recipeId: "sauce-mushroom",
    price: 9.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-sauces",
  },
  {
    id: "sauce-pepper",
    recipeId: "sauce-pepper",
    price: 9.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-sauces",
  },
  {
    id: "sauce-meat",
    recipeId: "sauce-meat",
    price: 12.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-sauces",
  },

  /* ---------------------- PREPARED MEALS ---------------------- */
  {
    id: "meal-house-rice",
    recipeId: "meal-house-rice",
    price: 14.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-prepared-meals",
  },
  {
    id: "meal-greek-potatoes",
    recipeId: "meal-greek-potatoes",
    price: 10.95,
    category: "grocery",
    location: "delson",
    popular: false,
    submenu: "delson-prepared-meals",
  },
];

// Live prices: overrides from Supabase (built into priceOverrides.generated.ts
// by scripts/generate-menu.ts). If the override is absent, the base price wins.
export const menuItems: MenuItem[] = baseMenuItems.map((item) =>
  priceOverrides[item.id] !== undefined
    ? { ...item, price: priceOverrides[item.id] }
    : item,
);

// Helper functions
export const getMenuItemsByCategory = (
  category: MenuItem["category"],
  location?: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.category === category &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getPopularItems = (
  location?: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.popular &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getNewItems = (location?: MenuItem["location"]): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.new &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getMenuItemsByLocation = (
  location: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) => item.location === location || item.location === "both",
  );
};

export const searchMenuItems = (
  query: string,
  location?: MenuItem["location"],
): MenuItem[] => {
  const lowerQuery = query.toLowerCase();
  return menuItems.filter(
    (item) =>
      (item.name?.toLowerCase().includes(lowerQuery) ||
        false ||
        item.description?.toLowerCase().includes(lowerQuery) ||
        false) &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getMenuItemById = (id: string): MenuItem | undefined => {
  return menuItems.find((item) => item.id === id);
};

export const getVegetarianItems = (
  location?: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.vegetarian &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getGlutenFreeItems = (
  location?: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.glutenFree &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

export const getMenuItemsBySubmenu = (
  submenu: string,
  location?: MenuItem["location"],
): MenuItem[] => {
  return menuItems.filter(
    (item) =>
      item.submenu === submenu &&
      (location
        ? item.location === location || item.location === "both"
        : true),
  );
};

// Category labels
export const categoryLabels = {
  specials: "Specials",
  lunch: "Lunch",
  dinner: "Dinner",
  grocery: "Grocery",
  "new-arrivals": "New Arrivals",
};

export const getCategoryLabel = (category: MenuItem["category"]): string => {
  return categoryLabels[category] || category;
};

// Re-export submenu labels and helper from menuConfig (single source of truth)
export { submenuLabels, getSubmenuLabel } from "./menuConfig";

// end of script
